require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-is-data-killing-creativity.json") })
        }
      }, "path---news-is-data-killing-creativity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-is-data-killing-creativity!./.cache/json/news-is-data-killing-creativity.json
// module id = 1427
// module chunks = 231608221292675